module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "policy",
    class: {
      'after-bottom-divider': !(_vm.lastChild || (_vm.hasTable && !_vm.refundPolicy.tips)),
    }
  }, [(_vm.scene === 'TAG') ? _c('div', {
    staticClass: "policy-title"
  }, [_c('img', {
    staticClass: "policy-icon",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(_vm._s(_vm.refundPolicy.title))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.refundPolicy.content) ? _c('div', {
    staticClass: "policy-content",
    style: (!_vm.hasTable && _vm.refundPolicy.tips && _vm.refundPolicy.content ? 'margin-bottom:0;' : '')
  }, [_vm._v(_vm._s(_vm.refundPolicy.content))]) : _vm._e(), _vm._v(" "), (_vm.refundPolicy.refundRuleList && _vm.refundPolicy.refundRuleList.length) ? [_c('div', {
    staticClass: "policy-tab-container"
  }, [_c('div', {
    ref: "scroll-container",
    staticClass: "event-options"
  }, _vm._l((_vm.refundPolicy.refundRuleList), function(item, index) {
    return _c('div', {
      key: item.name || index,
      ref: ("event-option-" + index),
      refInFor: true,
      class: ['event-options-item', _vm.targetPolicy.name === item.name ? 'event-options-item-active' : ''],
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.selectEvent(item, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('refund-policy-table', {
    attrs: {
      "policy-obj": _vm.targetPolicy,
      "type": "REFUND"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.refundPolicy.noTicketCompensateStandardVOList && _vm.refundPolicy.noTicketCompensateStandardVOList.length) ? [_c('refund-policy-table', {
    attrs: {
      "policy-array": _vm.refundPolicy.noTicketCompensateStandardVOList,
      "type": _vm.refundPolicy.type
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "policy-tips",
    style: (!_vm.hasTable && _vm.refundPolicy.tips && _vm.refundPolicy.content ? 'margin-top:0;' : '')
  }, [_vm._v(_vm._s(_vm.refundPolicy.tips))])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-857e2c08", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-857e2c08","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/activity/detail/RefundPolicy.vue
// module id = 2278
// module chunks = 47